export default __webpack_public_path__ + "static/media/invoices-image.6f4c0dee.svg";